import { useEffect, useRef, useState } from 'react'
import NextImage from 'next/image'
import { useInView } from 'react-intersection-observer'
import { TypeAnimation } from 'react-type-animation'

import { Section } from 'components/section'
import { cn } from 'utils'

import classes from './include-price.module.css'
import houseImg from './images/right-section-img.png'
import sold from './images/sold.png'

export const IncludePrice = () => {
  const { ref, inView } = useInView({
    threshold: 0.85,
  })
  let timeout = useRef<undefined | NodeJS.Timeout>(undefined)

  const [activateAnimation, setActivateAnimation] = useState(false)

  const additionalText =
    '$50,000 of price protection included in the sale — for added peace of mind.'

  useEffect(() => {
    if (!inView) {
      timeout.current && clearTimeout(timeout.current)
      setActivateAnimation(false)
      return
    }
    if (inView) {
      if (activateAnimation) {
        timeout.current && clearTimeout(timeout.current)
        timeout.current = setTimeout(() => {
          setActivateAnimation(false)
        }, 9000)
      }
      if (!activateAnimation) {
        timeout.current && clearTimeout(timeout.current)
        timeout.current = setTimeout(() => {
          setActivateAnimation(true)
        }, 1000)
      }
    }
  }, [inView, activateAnimation])

  return (
    <Section>
      <h2 className={classes.title}>
        Include price protection in the property listing, making it more attractive to potential
        buyers
      </h2>
      <div className={classes.cardWrapper}>
        <div className={classes.imgWrapper}>
          <NextImage
            src={houseImg.src}
            alt="house image"
            width={454}
            height={324}
            className={classes.img}
          />
          <NextImage
            src={sold.src}
            alt="sold stamp image"
            width={500}
            height={170}
            className={cn(classes.soldImg, activateAnimation && classes.showStamp)}
          />
          <div className={classes.priceSection}>
            <p className={classes.highlightedPrice}>$525,000</p>
            <p>4 bedrooms</p>
            <p>2.5 bathrooms</p>
            <p>3,400 sq ft</p>
          </div>
        </div>
        <div className={classes.textSectionWrapper}>
          <p className={classes.subtitle}>Classic Colonial in Family-Friendly Neighborhood</p>
          <p ref={ref} className={classes.details}>
            Immaculately maintained 4-bedroom Colonial in the heart of downtown. Freshly painted
            interiors, spacious living areas, and a chef&apos;s kitchen. A large master suite with
            walk-in closet and updated bath. Fenced backyard perfect for children and pets.{' '}
            {activateAnimation && (
              <TypeAnimation
                className={classes.animatedText}
                wrapper="span"
                sequence={[additionalText, 1000]}
                repeat={1}
                speed={55}
              />
            )}{' '}
            Don&apos;t miss this opportunity!
          </p>
        </div>
      </div>
    </Section>
  )
}
